import { Injectable } from "@angular/core";
import { EnumTipoDataControle } from "../enums/EnumDataControle";
import { StorageService } from "../services/storage.service";
import { DataControle } from "../models/dataControle";

@Injectable()
export class DataControleRepositorio {
  readonly databaseName = "svdm";
  readonly collectionName = "datas-controle";

  constructor(private storageService: StorageService) {}

  public async salvar(dataControle: DataControle): Promise<void> {
    await this.storageService.upsert(
      dataControle,
      this.databaseName,
      this.collectionName
    );
  }

  public async buscar(tipo: EnumTipoDataControle): Promise<DataControle> {
    return await this.storageService.getByKey<DataControle>(
      tipo.valueOf().toString(),
      this.databaseName,
      this.collectionName
    );
  }

  public generateDataControleTipo(tipo: EnumTipoDataControle): DataControle {
    return {
      tipo: tipo,
      data: new Date(),
      id: tipo.valueOf().toString(),
      dataHoraModificacao: new Date(),
      removido: false,
    };
  }
}
